import React from 'react';
import DatePickers from './DateAndTime';
import ProductForm from './ProductFormRef';
import FoeForm from './FoeFormRef';
import TextAccordion from './TextAccordionRef';
import SubmitButton from './SubmitButtonRef.js';
import TitleForm from './TitleFormRef';
import checkToken from '../../Token/checkToken';
import Menu from '../MenuBar';
import ContestRelease from './ContestRelease';
import ImageLoader from './ImageLoaderRef';
import GooglePlacesAutocomplete from './GooglePlacesAutocomplete';

export default class CreateRef extends React.Component {

    render() {

        return (
            <div className='createRefClassFull'>
            { checkToken() ? 
               <div>
               <Menu />

                <div className='createRefClass'>
                    <TitleForm />
                    <GooglePlacesAutocomplete/>
                    <ProductForm />
                    <FoeForm />
                    <DatePickers />
                    <TextAccordion />
                    <ImageLoader/>
                    <ContestRelease />
                    <SubmitButton />
                    </div>
            </div>
            : window.location.reload()} </div>
        )
    }

}